export const locale = {
  lang: 'zh1',
  data: {
    'NAV': {
      'APPLICATIONS': '應用領域',
      'CONFIG': '設定值',
      'TOOLS': {
        'TITULO': '工具類',
        'CHAT': '聊天室',
        'TODO': '待辦事項清單',
        'BROKER': '經紀人配置',
        'CHANGELOG': '變更日誌',
        'KNOWLEDGE': '知識庫',
        'WEB_COM_PROF':'網絡公司簡介',
      },
      'RESULTS': {
        'TITULO': '結果',
        'ENLACES': {
          'TI': '報告中',
          'TI_ESPANA': '在線報告',
          'COVID': 'COVID調查結果'
        },
        'ENLACES5': {
          'TI': '報告中 5.0',
          'COVID': 'Covid调查结果'
        },
        'ENLACES_ACTION_GO':{
          'TITULO':'ActionGo',
          // 'TITULO':'行動計劃-領導人',
        },
        'ENLACES_GO_FLOW':{
          'TITULO':'去流結果',
        }
      },
      'ACADEMY'        : {
        'TITULO': '測試學院',
        'BADGE': '69'
      },
      'CERTIFICAR'        : {
        'TITULO': '證明',
        'BADGE': '69',
        'SUBPRODUCTOS': {
          '0': '證明',
          '1': '認證2.0',
          '3': '認證3.0',
          '4': '認證銀',
          'SPA': '配置調查'
        }
      },
      'CERTIFICARN35'        : {
        'TITULO': '認證NOM35',
        'BADGE': '69'
      },
      'MEDIR'        : {
        'TITULO': '測量',
        'BADGE': '69',
        'SUBPRODUCTOS': {
          '0': '測量',
          '1': '測量增強',
          '2': '測量+ MST',
          '3': '按面積測量',
          '4': '領導者衡量',
          '5': '尺寸測量',
          '6': '測量證明',
          '7': '測量 3.0',
        }
      },
      'PULSE'        : {
        'TITULO': '脈衝檢查',
        'BADGE': '69',
        'SUBPRODUCTOS': {
          '0': '脈衝檢查',
          '1': '脈衝檢查 3.0',
        }
      },
      'FOCUS'        : {
        'TITULO': '重點地區',
        'BADGE': '69'
      },
      'ENCUESTAS':{
                 'TITULO': '附加認證',
                 'BADGE': '69',
                 'SUBPRODUCTOS':{
                   '0': 'AMCO',
                   '1': '體面的工作',
                   '2': '第一份工作',
                 }
             },
             'NORMA35': {
                 'TITULO': 'Norm 035'
             },
             'NOM35BETHE': {
                 'TITULO': 'Norm 035 better'
             },
             'NOM35PLA': {
                 'TITULO': 'Norm 035 silver'
             },
             'NOM35V3': {
                 'TITULO': 'Norm 035 3.0'
             },
      'LANGUAJE'        : {
        'TITULO': '測試蘭瓜耶',
        'BADGE': '69'
      },
      'LOGIN'        : {
        'TITULO': '測試登錄',
        'BADGE': '69'
      },
      'PROFILECREATOR'        : {
        'TITULO': '個人資料創建者',
        'BADGE': '69'
      },
      'PROFILELIST'        : {
        'TITULO': '公司資料',
        'BADGE': '69'
      },
      'NOPRODUCTOS'        : {
        'TITULO': '您沒有產品',
        'BADGE': '69'
      },
      'RESPTI': {
        'TITULO': 'IT經理'
      },
      'REQTEC': {
        'TITULO': '技術要求'
      },
      'CLOUD': {
        'TITULO': '文件管理器',
        'TITULO_ESPANA': '報告下載',
      },
      //Culture Audit
      'CULTURE': {
        'TITULO': '文化評估'
      },
      //Culture Audit2
      'CULTURE2': {
        'TITULO': '文化評估5.0'
      },
      //Culture Audit training
      'CATR': {
        'TITULO': '文化審核培訓'
      },
      //Feedback
      'FEEDBACK': {
        'TITULO': '反饋'
      },
      //Acercade
      'ABOUT': {
        'TITULO': '變更日誌'
      },
      'QUESTIONS': {
        'TITULO': '常問問題'
      },
      'VIDEOS': {
        'TITULO': '教學視頻'
      },
      'CONSULTAR_E': {
        'TITULO': '諮詢調查'
      },
      'CALEND_SUR': {
        'TITULO':'調查日曆'
      },
      'VIDEOSADMIN': {
        'TITULO': '管理員影片'
      },
      'AUDITORIA-AUTO': {
          'TITULO':'自動審核'
        },
        'CULTURETURQUIA1': {
          'TITULO': '文化簡介文化審核5.0'
        },'CULTURETURQUIA2': {
          'TITULO': '文化簡介5.0'
        },'CULTURETURQUIA3': {
          'TITULO': '文化審核5.0'
        },
        'CULTUREMX1': {
          'TITULO': '文化審核5.0'
        },'CULTUREMX2': {
          'TITULO': '文化審核哥斯達黎加'
        },'CULTUREMX3': {
          'TITULO': '文化審核GoFlow'
        },'CULTUREMX4': {
          'TITULO': '文化審核5.0巴拿馬'
        },'CULTUREMX5': {
          'TITULO': '文化審核5.0戰略合作夥伴'
        },
        'CULTUREMX11': {
          'TITULO': 'SP 2022'
        },
        'CULTUREMX12': {
          'TITULO': '文化審計 GoFlow 2-2022'
        },
        'CULTUREMX13': {
          'TITULO': '文化審核標準 1'
        },
        'CULTUREMX14': {
          'TITULO': '文化審計® CA&C'
        },
        'CULTUREMX15': {
          'TITULO': '文化審核（認證）2022'
        },
        'CULTUREMX16': {
          'TITULO': '文化審計（認證, rkg.） 2022'
        },
        'CULTUREMX17': {
          'TITULO': '文化審計(認證, rkg. y adic.) 2022'
        },
        'CULTUREMX18': {
          'TITULO': '文化審計(認證, rkg. y adic.) 2024'
        },
        'CULTUREMX19': {
          'TITULO': '文化簡報（認證）2024'
        },
        'CULTUREMX20': {
          'TITULO': '文化審計（認證和排名）2024'
        },
        'CULTURECH1': {
          'TITULO': '文化審核'
        },'CULTURECH2': {
          'TITULO': '文化評估5.0'
        },'CULTURECH3': {
          'TITULO': '文化審核SP'
        },'CULTURECH4': {
          'TITULO': '文化審計 5.0'
        },'CULTURECH5': {
          'TITULO': '4ALL 文化評估'
        },
        'CULTUREESP1':{
          'TITULO': '文化審核'
        },
        'CULTUREESP2':{
          'TITULO': '文化審核 5.0'
        },
        'CULTUREESP3':{
          'TITULO': 'Action Plan'
        },
        'CULTUREBRI':{
          'TITULO': '文化簡介',
          'Culture Brief': '文化簡介',
        },
        'CULTUREAUDI':{
          'TITULO': '文化審計',
          'Culture Audit': '文化審計',
        },
        'CONTACTO':{
          'TITULO': '聯繫'
        },
        'ACTIONGOADMIN':{
          'TITULO': '行動GO® 管理員'
        },
        'ACTIONGO':{
          'TITULO': '行動GO®'
        },
        'LEADERGOADMIN':{
          'TITULO': '領導者 GO® 管理員',
        },
        'LEADERGOUSER':{
          'TITULO': '領導者 GO®',
        },
        'medir_INNO':{
          'TITULO': '動感調查',
        },
        'CULTURE_OZEL':{
          'TITULO': '特別清單',
        },
        'Culture_Ozel_TR1':{
          'TITULO': '社會責任和志願服務',
        },
        'CONTROL_SURVE':{
          'TITULO': '測量控制',
        },
        'CONSUL_REQUE':{
          'TITULO': '諮詢要求',
        },
        'SURVEY_GENERIC':{
        'TITULO': '通用調查報告',
      },

    }
  }
};
